import {
  heydayPath,
  heydayPersonPath,
  navigateToHeydayPage,
  navigateToHeydayPerson,
  peopleWorkerIDFromPathname,
  subscribeToHeydayLocation,
} from '../../config/heydayRoutes';
import type { PeopleRoutePort } from '../../features/people/public';

export const peopleRouteAdapter: PeopleRoutePort = {
  read() {
    const requestedAsOf = new URLSearchParams(window.location.search).get('asOf') ?? '';
    return {
      workerId: peopleWorkerIDFromPathname(window.location.pathname),
      asOf: /^\d{4}-\d{2}-\d{2}$/.test(requestedAsOf) ? requestedAsOf : undefined,
      action: new URLSearchParams(window.location.search).get('action') === 'create' ? 'create' : new URLSearchParams(window.location.search).get('action') === 'contracts' ? 'contracts' : undefined,
    };
  },
  clearCreateAction() {
    const query = new URLSearchParams(window.location.search);
    query.delete('action');
    const workerId = peopleWorkerIDFromPathname(window.location.pathname);
    if (workerId) navigateToHeydayPerson(workerId, query, { replace: true }); else navigateToHeydayPage('people', query, { replace: true });
  },
  openWorker(workerId, asOf, options) {
    const query = new URLSearchParams(window.location.search);
    query.set('asOf', asOf);
    navigateToHeydayPerson(workerId, query, options);
  },
  closeWorker() {
    navigateToHeydayPage('people', new URLSearchParams(window.location.search));
  },
  openWorkflowRequest(requestId) {
    navigateToHeydayPage('my-workflow-requests', new URLSearchParams({ request: requestId }));
  },
  openOnboarding(workerId, targetOn) {
    const parameters = new URLSearchParams({ action: 'onboarding', worker: workerId });
    if (targetOn) parameters.set('targetOn', targetOn);
    navigateToHeydayPage('lifecycle', parameters);
  },
  openBulkHire() {
    navigateToHeydayPage('bulk', 'operation=EMPLOYEE_HIRE');
  },
  openBulkJob(id) { navigateToHeydayPage('bulk', new URLSearchParams({ job: id })); },
  openStaffing() { navigateToHeydayPage('staffing'); },
  personnelRemedyLink(remedy, { workerId, effectiveDate }) {
    const workerQuery = new URLSearchParams({ worker: workerId, asOf: effectiveDate });
    switch (remedy) {
      case 'STAFFING_REQUESTS': return { href: heydayPath('staffing'), label: '진행 중 발령 보기' };
      case 'WORKFLOW_REQUESTS': return { href: heydayPath('workflow-requests'), label: '진행 중 요청 보기' };
      case 'ORGANIZATIONS': return { href: heydayPath('organization'), label: '조직 리더 확인' };
      case 'PEOPLE': return { href: heydayPersonPath(workerId, new URLSearchParams({ asOf: effectiveDate })), label: '보고 관계 확인' };
      case 'WORKER_CONTRACTS': return { href: heydayPersonPath(workerId, new URLSearchParams({ asOf: effectiveDate, action: 'contracts' })), label: '계약 확인' };
      case 'WORKER_COMPENSATION': return { href: heydayPath('rewards', new URLSearchParams({ worker: workerId, kind: 'COMPENSATION' })), label: '보상 확인' };
      case 'WORKER_BENEFITS': return { href: heydayPath('rewards', new URLSearchParams({ worker: workerId, kind: 'BENEFIT' })), label: '복리후생 확인' };
      case 'ABSENCE_BALANCES': return { href: heydayPath('absence', workerQuery), label: '휴가 잔여 확인' };
      case 'ABSENCE_REQUESTS': return { href: heydayPath('absence', workerQuery), label: '휴가 요청 확인' };
    }
  },
  openStaffingPlan({ workerId, organizationId, effectiveDate, view }) {
    const query = new URLSearchParams({ planId: 'new', view, worker: workerId, effectiveDate });
    if (organizationId) query.set('organization', organizationId);
    navigateToHeydayPage('organization', query);
  },
  subscribe: subscribeToHeydayLocation,
};
